import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle, Star, ShieldCheck, Download, Users, BookOpen, Gift, ArrowRight, Check, Clock } from 'lucide-react';
import { Button } from './components/ui/Button';
import { CtaButton } from './components/ui/CtaButton';
import { Countdown } from './components/ui/Countdown';
import { Testimonials } from './components/Testimonials';
import { TableroDetails } from './components/TableroDetails';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { MetaPixel, trackPixel } from './components/MetaPixel';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/esg6LUXakFFA3Pv8K5C7sC/mockup_pack_anti_pantalla.png';
const CHECKOUT_BASICO = 'https://www.impulsolab.store/cart/66925404684333:1';
const CHECKOUT_PREMIUM = 'https://www.impulsolab.store/cart/66925409173549:1';
export function App() {
  return <div className="min-h-screen bg-zinc-950 text-zinc-100 selection:bg-yellow-400/30" data-id="element-0" data-mp="23utadzydnu97">
      <MetaPixel data-id="element-1" data-mp="3ij65gd4jrr9g" />
      {/* Top Banner */}
      <div className="bg-yellow-400 text-zinc-950 py-2 px-4 text-center text-sm font-bold tracking-wide" data-id="element-2" data-mp="3mljat0fdtn5p">
        🚀 IMPULSO LAB™ | Todo el entretenimiento de tu hijo. Listo. Desde hoy.
      </div>

      {/* Hero Section */}
      <section className="relative pt-10 pb-16 px-4 overflow-hidden" data-id="element-3" data-mp="6htjo98ovic">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-yellow-400/10 rounded-full blur-[120px] pointer-events-none" data-id="element-4" data-mp="2zl3a7gleoy37" />

        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-5" data-mp="33myn7icp8zwt">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-zinc-900 border border-zinc-800 text-zinc-300 text-xs mb-6" data-id="element-6" data-mp="38kqbm2e4y3w9">
            <span className="flex h-2 w-2 rounded-full bg-yellow-400 animate-pulse" data-id="element-7" data-mp="swgk5o3310p4" />
            El sistema N°1 para mamás que quieren reducir pantallas
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-extrabold tracking-tight mb-4 leading-tight" data-id="element-8" data-mp="3ucjc5sple9t7">
            IMPULSO LAB <br data-id="element-9" data-mp="3bncp5thrmw1l" />
            <span className="text-yellow-400" data-id="element-10" data-mp="3bnuvjiy56qn8">MegaPack Anti-Pantallas</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-base md:text-lg text-zinc-400 max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-11" data-mp="3qcqy50hfjbgg">
            Actividades + rutinas + planificación + gamificación listas para
            usar.{' '}
            <strong className="text-zinc-200 font-semibold" data-id="element-12" data-mp="1d4reqwr1tpe7">
              Sin improvisar. Sin inventar cada día. Sin pelear por el celular.
            </strong>
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3
        }} className="relative max-w-[260px] mx-auto mb-8" data-id="element-13" data-mp="13eevd7uz029n">
            <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent z-10 h-full w-full" data-id="element-14" data-mp="1i2t0jpfv02td" />
            <img src={PRODUCT_IMAGE} alt="MegaPack Anti-Pantallas" className="w-full h-auto drop-shadow-[0_0_40px_rgba(250,204,21,0.3)] relative z-0" data-id="element-15" data-mp="1m78zf6r229z3" />
          </motion.div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-8 text-xs md:text-sm font-medium text-zinc-300" data-id="element-16" data-mp="qwvrwf96wp6w">
            <div className="flex items-center gap-2" data-id="element-17" data-mp="m5dzifl8fwxj">
              <Download className="w-4 h-4 text-yellow-400" data-id="element-18" data-mp="m4m5vab7499w" /> 100% PDF
            </div>
            <div className="flex items-center gap-2" data-id="element-19" data-mp="h59ecc9dqe0z">
              <Clock className="w-4 h-4 text-yellow-400" data-id="element-20" data-mp="c9alabd3w7u8" /> Acceso en 5 min
            </div>
            <div className="flex items-center gap-2" data-id="element-21" data-mp="19w9ol4yb0e13">
              <Users className="w-4 h-4 text-yellow-400" data-id="element-22" data-mp="19tnht7j8m2jx" /> Niños de 3 a 10 años
            </div>
          </div>

          <Button size="lg" className="w-full md:w-auto mb-6" onClick={() => document.getElementById('ofertas')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-23" data-mp="zxttys02immu">
            QUIERO MI MEGAPACK AHORA <ArrowRight className="ml-2 w-5 h-5" data-id="element-24" data-mp="3klq1dnic3k6h" />
          </Button>

          <div className="flex justify-center items-center gap-6 text-xs text-zinc-500" data-id="element-25" data-mp="3gkwduv8t07e4">
            <span className="flex items-center gap-1" data-id="element-26" data-mp="1w5q3yefms39y">
              <ShieldCheck className="w-4 h-4" data-id="element-27" data-mp="205quuyjx26xw" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-28" data-mp="203nt5h9eipdc">
              <CheckCircle2 className="w-4 h-4" data-id="element-29" data-mp="254bky55gfa8m" /> Pago seguro
            </span>
          </div>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="border-y border-zinc-900 bg-zinc-900/30 py-8" data-id="element-30" data-mp="2euwtakaxjt4q">
        <div className="max-w-5xl mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-zinc-800" data-id="element-31" data-mp="2eun2wvlz3jyi">
          <div data-id="element-32" data-mp="2nvl6xdwevrh3">
            <div className="text-3xl font-bold text-white mb-1" data-id="element-33" data-mp="2nv32htzli6y3">+500</div>
            <div className="text-sm text-zinc-400 uppercase tracking-wide" data-id="element-34" data-mp="2nts120tmhba5">
              Mamás confían
            </div>
          </div>
          <div data-id="element-35" data-mp="tid9deh1x1rr">
            <div className="text-3xl font-bold text-white mb-1" data-id="element-36" data-mp="tivc8ty7ye8n">6</div>
            <div className="text-sm text-zinc-400 uppercase tracking-wide" data-id="element-37" data-mp="yg50455ymhud">
              Tomos listos
            </div>
          </div>
          <div data-id="element-38" data-mp="21s3yx89z6yoq">
            <div className="text-3xl font-bold text-white mb-1" data-id="element-39" data-mp="21ru519lt87dr">6</div>
            <div className="text-sm text-zinc-400 uppercase tracking-wide" data-id="element-40" data-mp="1wtsp2xjoko6i">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-41" data-mp="2apw3pii2mnxv">
            <div className="text-3xl font-bold text-white mb-1 flex items-center justify-center gap-1" data-id="element-42" data-mp="25t5rx7dauei9">
              4.9/5 <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-43" data-mp="2kpwq5db8lk6a" />
            </div>
            <div className="text-sm text-zinc-400 uppercase tracking-wide" data-id="element-44" data-mp="2frlfj0d4b5n0">
              Calificación
            </div>
          </div>
        </div>
      </section>

      <Testimonials data-id="element-45" data-mp="2thyrrex1l6i5" />

      {/* Problem Agitation */}
      <section className="py-16 px-4 bg-zinc-950" data-id="element-46" data-mp="2pgwnuks6k69u">
        <div className="max-w-4xl mx-auto" data-id="element-47" data-mp="2pj9b9dgpj8ua">
          <div className="text-center mb-10" data-id="element-48" data-mp="33g4qjnnjxwis">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-49" data-mp="33etmdmq72mr5">
              ¿Cuántas veces más vas a ceder el celular con culpa?
            </h2>
            <p className="text-lg text-zinc-400" data-id="element-50" data-mp="3i3d4uxc5qhyz">
              No es falta de amor.{' '}
              <strong className="text-yellow-400 font-semibold" data-id="element-51" data-mp="3n398uwkuu9ej">
                Es falta de un sistema.
              </strong>
            </p>
          </div>

          <div className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-6 md:p-8 grid md:grid-cols-2 gap-4" data-id="element-52" data-mp="387jikm8mza40">
            {['Tu hijo pide el celular cada 5 minutos.', 'Cedés la pantalla con culpa sin tener otra opción.', 'Compraste cosas que duraron 2 días.', 'Los días de lluvia son una pesadilla.'].map((pain, i) => <div key={i} className="flex items-start gap-3" data-id="element-53" data-mp="2pcutza56zcb0" data-mpi={i}>
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-54" data-mp="2uf3le22f26b0" />
                <p className="text-zinc-300" data-id="element-55" data-mp="2gdraw660ywwi">{pain}</p>
              </div>)}
          </div>

          <div className="mt-10 text-center" data-id="element-56" data-mp="2kg4dwmte0gpl">
            <p className="text-yellow-400 text-xl font-medium mb-6" data-id="element-57" data-mp="2kf356ozug6b1">
              ¿Y si este fuera el último día que pasás así?
            </p>
            <CtaButton label="QUIERO LA SOLUCIÓN" data-id="element-58" data-mp="2vvr8s5n63syf" />
          </div>
        </div>
      </section>

      {/* The Solution / Tomos */}
      <section className="py-16 px-4 bg-zinc-900/20 border-t border-zinc-900 relative" data-id="element-59" data-mp="2qvwdzr09uj83">
        <div className="max-w-6xl mx-auto" data-id="element-60" data-mp="2lx33m7ga78c5">
          <div className="text-center mb-10" data-id="element-61" data-mp="2m0h397xk93fw">
            <div className="text-yellow-400 font-bold tracking-widest uppercase text-sm mb-4" data-id="element-62" data-mp="2hxksg3e9ibmi">
              La Solución Definitiva
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-63" data-mp="2d3ye86sg9zol">
              6 Tomos Completos. 400+ páginas.
            </h2>
            <p className="text-xl text-zinc-400" data-id="element-64" data-mp="23853msyakg9g">
              Imprimís y el niño arranca solo.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-65" data-mp="1y78pzno51fqu">
            {[{
            title: 'Desafíos de Lógica',
            desc: '40 actividades en 4 niveles: secuencias, sudoku y acertijos.',
            color: 'bg-blue-500'
          }, {
            title: 'Arte sin Desorden',
            desc: '40 actividades limpias: coloreado, mandalas y proyectos creativos.',
            color: 'bg-purple-500'
          }, {
            title: 'Laberintos Evolutivos',
            desc: '35 laberintos de fácil a experto, con desafíos especiales.',
            color: 'bg-green-500'
          }, {
            title: 'Lectoescritura Jugada',
            desc: "40 actividades: sopas de letras, crucigramas y 'Mi Primer Libro'.",
            color: 'bg-red-500'
          }, {
            title: 'Naturaleza en Casa',
            desc: '40 páginas de ciencia: experimentos y proyectos caseros.',
            color: 'bg-orange-500'
          }, {
            title: 'Misiones Épicas',
            desc: '35 misiones: origami, inventos y el reto de 24hs sin pantallas.',
            color: 'bg-cyan-500'
          }].map((tomo, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 hover:border-zinc-700 transition-colors group" data-id="element-66" data-mp="2k818gzcrt1cp" data-mpi={i}>
                <div className={`w-12 h-12 rounded-xl ${tomo.color} bg-opacity-20 flex items-center justify-center mb-6`} data-id="element-67" data-mp="2u2bdphmt9u4u">
                  <BookOpen className={`w-6 h-6 ${tomo.color.replace('bg-', 'text-')}`} data-id="element-68" data-mp="21gryyq302cl4" />
                </div>
                <div className="text-zinc-500 text-sm font-bold mb-2 uppercase tracking-wider" data-id="element-69" data-mp="26cyurq1om7pc">
                  Tomo {i + 1}
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-70" data-mp="1dp34p46mbe1j">
                  {tomo.title}
                </h3>
                <p className="text-zinc-400 leading-relaxed" data-id="element-71" data-mp="1ino5b4ps7zqi">{tomo.desc}</p>
              </div>)}
          </div>

          <div className="mt-12 bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-72" data-mp="3vx62rtxczzdz">
            <div className="space-y-4" data-id="element-73" data-mp="3mxrduywubwvl">
              <h4 className="text-xl font-bold text-white" data-id="element-74" data-mp="3n0x1e9ptmqp7">
                Cada tomo incluye:
              </h4>
              <ul className="space-y-2" data-id="element-75" data-mp="3i23qmp1x5dsq">
                {['4 niveles de dificultad progresiva', 'Sistema de logros y diplomas', 'Instrucciones claras para no explicar nada', 'Diseñado para imprimir en A4'].map((item, i) => <li key={i} className="flex items-center gap-3 text-zinc-300" data-id="element-76" data-mp="2z9rnw17csai2" data-mpi={i}>
                    <CheckCircle2 className="w-5 h-5 text-yellow-400 shrink-0" data-id="element-77" data-mp="2ua59hofsgo7o" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <img src={PRODUCT_IMAGE} alt="Pack" className="w-64 h-auto drop-shadow-2xl" data-id="element-78" data-mp="2pd529a77dfez" />
          </div>

          <div className="mt-10 text-center" data-id="element-79" data-mp="2knkm70fewjlp">
            <CtaButton label="LO QUIERO PARA MI HIJO" data-id="element-80" data-mp="2kk6hvmn6u0bm" />
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-16 px-4 bg-zinc-950" data-id="element-81" data-mp="2ao3igojq0fsd">
        <div className="max-w-5xl mx-auto" data-id="element-82" data-mp="2aomyu0tq2w4a">
          <div className="text-center mb-10" data-id="element-83" data-mp="2ye7f2byhrf9v">
            <div className="inline-flex items-center gap-2 bg-yellow-400/10 text-yellow-400 px-4 py-1.5 rounded-full text-sm font-bold mb-4 border border-yellow-400/20" data-id="element-84" data-mp="2yeh8yamnq6ku">
              <Gift className="w-4 h-4" data-id="element-85" data-mp="2pmf8wdgi2sb3" /> SIEMPRE INCLUIDOS
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-86" data-mp="2tmz95pwdec1g">
              6 Bonos Estratégicos
            </h2>
            <p className="text-lg text-zinc-400" data-id="element-87" data-mp="3hcjqy5gsf395">
              Para que el sistema funcione desde el día 1.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-88" data-mp="3m4texfycdt8s">
            {[{
            title: 'Plan de Rescate 7 Días',
            desc: 'El plan paso a paso para empezar sin improvisar.',
            value: '$15.000'
          }, {
            title: 'Kit de Inicio Rápido',
            desc: "Setup en 10 minutos. Sistema 'agarro y uso'.",
            value: '$12.000'
          }, {
            title: '30 Frases Mágicas',
            desc: 'Las palabras exactas para cortar el celular sin peleas.',
            value: '$10.000'
          }, {
            title: 'Rutina Express 30 Min',
            desc: 'La fórmula 5-20-5 para bloques reales de calma.',
            value: '$12.000'
          }, {
            title: 'Checklist de Emergencia',
            desc: 'Protocolo de 3 minutos para los días de caos.',
            value: '$10.000'
          }, {
            title: 'Menú Semanal',
            desc: '9 menús armados para no preguntarte qué darle hoy.',
            value: '$10.000'
          }].map((bono, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 flex gap-4" data-id="element-89" data-mp="qnhtybr65aq4" data-mpi={i}>
                <div className="w-12 h-12 rounded-full bg-yellow-400/10 flex items-center justify-center shrink-0 text-yellow-400 font-bold text-xl" data-id="element-90" data-mp="vndxk9vyf055">
                  0{i + 1}
                </div>
                <div data-id="element-91" data-mp="15jh926cp4b4r">
                  <h3 className="text-lg font-bold text-white mb-2" data-id="element-92" data-mp="15inzyyq9l9jg">
                    {bono.title}
                  </h3>
                  <p className="text-zinc-400 text-sm mb-4" data-id="element-93" data-mp="1ed2n1nh1dod4">{bono.desc}</p>
                  <div className="flex items-center gap-2 text-sm" data-id="element-94" data-mp="1ef6q63742jcc">
                    <span className="text-zinc-600 line-through" data-id="element-95" data-mp="1jdi00dxeotuk">
                      {bono.value}
                    </span>
                    <span className="text-yellow-400 font-bold" data-id="element-96" data-mp="1o95r4yvg7x2p">GRATIS</span>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="mt-10 text-center p-6 bg-yellow-400/5 border border-yellow-400/20 rounded-2xl" data-id="element-97" data-mp="1tfc9hazqe1hq">
            <p className="text-xl text-zinc-300 mb-6" data-id="element-98" data-mp="1ohj42k695bii">
              Valor total bonos:{' '}
              <span className="line-through text-zinc-500" data-id="element-99" data-mp="1kgqs3j5zwsij">$69.000</span>{' '}
              <strong className="text-yellow-400" data-id="element-100" data-mp="2h5y708c403dh">
                GRATIS con tu MegaPack
              </strong>
            </p>
            <CtaButton label="QUIERO TODO ESTO GRATIS" data-id="element-101" data-mp="2c750x0z5jenc" />
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section id="ofertas" className="py-16 px-4 bg-zinc-900/30 border-y border-zinc-900 scroll-mt-4" data-id="element-102" data-mp="27dshr6d8s01z">
        <div className="max-w-5xl mx-auto" data-id="element-103" data-mp="2zvxskl8qr0c5">
          <div className="text-center mb-12" data-id="element-104" data-mp="2zxqytzffzijm">
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-105" data-mp="2v5pq2nhhg9yc">
              Elegí tu MegaPack
            </h2>
            <Countdown data-id="element-106" data-mp="t7dx1d6lznea" />
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-107" data-mp="t8ffw3tv9e6k">
            {/* Standard */}
            <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8 flex flex-col" data-id="element-108" data-mp="y68o12eqci9h">
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-109" data-mp="jhksux8sqak2">
                📘 MegaPack Anti-Pantallas
              </h3>
              <p className="text-zinc-400 mb-6 h-12" data-id="element-110" data-mp="oeuioe03ko8f">
                Ideal para: empezar hoy y reducir pantallas esta semana.
              </p>

              <div className="mb-8" data-id="element-111" data-mp="fhk4okvwakzt">
                <div className="text-zinc-500 line-through text-lg mb-1" data-id="element-112" data-mp="feft32g3omz4">
                  $49.000 ARS
                </div>
                <div className="text-5xl font-extrabold text-white" data-id="element-113" data-mp="5i324cbxwn82">
                  $19.990{' '}
                  <span className="text-xl text-zinc-500 font-medium" data-id="element-114" data-mp="1uxiz6tclaihl">ARS</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-115" data-mp="1zwm6kkg1l0sq">
                <li className="flex items-start gap-3" data-id="element-116" data-mp="1zu9ma0mtaeci">
                  <Check className="w-5 h-5 text-yellow-400 shrink-0" data-id="element-117" data-mp="3kfg5bn3pt35a" />{' '}
                  <span className="text-zinc-300" data-id="element-118" data-mp="3ffts3dnvzmwh">6 Tomos Completos</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-119" data-mp="3u4pyl6aaoruz">
                  <Check className="w-5 h-5 text-yellow-400 shrink-0" data-id="element-120" data-mp="3u5izvrqhip5q" />{' '}
                  <span className="text-zinc-300" data-id="element-121" data-mp="3pcpud1n6zcsl">6 Bonos Estratégicos</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-122" data-mp="6y727brk5d3q">
                  <Check className="w-5 h-5 text-yellow-400 shrink-0" data-id="element-123" data-mp="2y6ppwo0rbzb" />{' '}
                  <span className="text-zinc-300" data-id="element-124" data-mp="309e6c9iwx1x">
                    240 páginas de actividades
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-125" data-mp="bybnrg7boy0t">
                  <Check className="w-5 h-5 text-yellow-400 shrink-0" data-id="element-126" data-mp="bws5xl60qewx" />{' '}
                  <span className="text-zinc-300" data-id="element-127" data-mp="2ipb2s5tto61g">120 páginas de guías</span>
                </li>
              </ul>

              <Button variant="outline" fullWidth onClick={() => {
              trackPixel('InitiateCheckout', {
                content_name: 'MegaPack Anti-Pantallas',
                value: 19990,
                currency: 'ARS'
              });
              window.location.href = CHECKOUT_BASICO;
            }} data-id="element-128" data-mp="2ds2le7gi0619">
                QUIERO MI MEGAPACK
              </Button>
            </div>

            {/* Premium */}
            <div id="oferta-premium" className="bg-zinc-900 border-2 border-yellow-400 rounded-3xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_40px_rgba(250,204,21,0.15)] scroll-mt-8" data-id="element-129" data-mp="1dx18kkbwqg9a">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-yellow-400 text-zinc-950 px-4 py-1 rounded-full text-sm font-bold tracking-wide" data-id="element-130" data-mp="1nvyrn7qkdhkw">
                MÁS ELEGIDO ⭐
              </div>

              <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-131" data-mp="2z8j82v2vr8rv">
                🏆 MegaPack + Tablero
              </h3>
              <p className="text-zinc-400 mb-6 h-12" data-id="element-132" data-mp="ine6cyczseol">
                Ideal para: convertir el pack en un hábito de por vida con
                gamificación total.
              </p>

              <div className="mb-8" data-id="element-133" data-mp="8ye2b0jmut3j">
                <div className="text-zinc-500 line-through text-lg mb-1" data-id="element-134" data-mp="8xbcyx1ykypq">
                  $69.000 ARS
                </div>
                <div className="text-5xl font-extrabold text-yellow-400" data-id="element-135" data-mp="40chob6k6lpy">
                  $27.990{' '}
                  <span className="text-xl text-zinc-500 font-medium" data-id="element-136" data-mp="3w4wzuye3wdwd">ARS</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-137" data-mp="3m4mlvbk8z2g5">
                <li className="flex items-start gap-3" data-id="element-138" data-mp="3m67dasb9m59s">
                  <Check className="w-5 h-5 text-zinc-600 shrink-0" data-id="element-139" data-mp="1pcw5hs3k5x87" />{' '}
                  <span className="text-zinc-400" data-id="element-140" data-mp="1pa06e0fz52i6">
                    Todo lo del MegaPack Básico
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-141" data-mp="2c6avddyti1dy">
                  <Check className="w-5 h-5 text-yellow-400 shrink-0" data-id="element-142" data-mp="2c96xlehp7c87" />{' '}
                  <span className="text-white font-semibold" data-id="element-143" data-mp="27917i2r2txs8">
                    Tablero de Control Familiar
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-144" data-mp="1xj7zfbq580sq">
                  <Check className="w-5 h-5 text-yellow-400 shrink-0" data-id="element-145" data-mp="1xglrvc395lai" />{' '}
                  <span className="text-white font-semibold" data-id="element-146" data-mp="1tifli56bt7q4">
                    Árbol de Habilidades & Rangos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-147" data-mp="1ji5amr7rkce4">
                  <Check className="w-5 h-5 text-yellow-400 shrink-0" data-id="element-148" data-mp="1jkri6qunmrwc" />{' '}
                  <span className="text-white font-semibold" data-id="element-149" data-mp="1el53ecz6h3lf">
                    400 páginas totales
                  </span>
                </li>
              </ul>

              <Button variant="primary" fullWidth onClick={() => {
              trackPixel('InitiateCheckout', {
                content_name: 'MegaPack + Tablero Premium',
                value: 27990,
                currency: 'ARS'
              });
              window.location.href = CHECKOUT_PREMIUM;
            }} data-id="element-150" data-mp="38xd5ca9x2kqp">
                QUIERO EL MEGAPACK + TABLERO
              </Button>
            </div>
          </div>
        </div>
      </section>

      <TableroDetails data-id="element-151" data-mp="2yhkkwcpyuszk" />
      <FAQ data-id="element-152" data-mp="32hcyx4y4prcb" />
      <CostOfInaction data-id="element-153" data-mp="32h35t8hsf42e" />

      {/* Final CTA */}
      <section className="py-16 px-4 bg-zinc-950 text-center" data-id="element-154" data-mp="32hv2kmn4f7u9">
        <div className="max-w-3xl mx-auto" data-id="element-155" data-mp="37fwjp20zkx33">
          <Countdown data-id="element-156" data-mp="37f4qtyyrxdgi" />
          <Button size="xl" className="w-full md:w-auto mt-8 mb-8" onClick={() => document.getElementById('ofertas')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-157" data-mp="37ish8p8x9jr0">
            QUIERO MI MEGAPACK AHORA <ArrowRight className="ml-2 w-6 h-6" data-id="element-158" data-mp="rr4pd88rmhf2" />
          </Button>
          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-zinc-400" data-id="element-159" data-mp="1zl6az688ls9">
            <span className="flex items-center gap-2" data-id="element-160" data-mp="3t6xpfjqo79at">
              <ShieldCheck className="w-4 h-4 text-yellow-400" data-id="element-161" data-mp="bz2djl14n7qc" /> Garantía 7
              días
            </span>
            <span className="flex items-center gap-2" data-id="element-162" data-mp="6zzfikjke1rv">
              <CheckCircle2 className="w-4 h-4 text-yellow-400" data-id="element-163" data-mp="6y6b7bwfbtn1" /> Pago 100%
              seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-164" data-mp="3agzk3be9buav">
              <Clock className="w-4 h-4 text-yellow-400" data-id="element-165" data-mp="3aiiyewgcrva0" /> Acceso en 5 minutos
            </span>
          </div>
        </div>
      </section>

      {/* Footer / Guarantee */}
      <footer className="py-16 px-4 bg-zinc-950 text-center border-t border-zinc-900" data-id="element-166" data-mp="3kevolkcovr00">
        <div className="max-w-3xl mx-auto" data-id="element-167" data-mp="2wp1db780qahv">
          <div className="flex justify-center mb-8" data-id="element-168" data-mp="2wnqd1hds7kvi">
            <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 max-w-md" data-id="element-169" data-mp="2rqzyiyhmkxc7">
              <ShieldCheck className="w-12 h-12 text-yellow-400 mx-auto mb-4" data-id="element-170" data-mp="178pbgut0en58" />
              <h4 className="text-xl font-bold text-white mb-2" data-id="element-171" data-mp="1bz5s0ns4movt">
                Garantía 7 Días
              </h4>
              <p className="text-zinc-400 text-sm" data-id="element-172" data-mp="xajemrm28778">
                Imprimís el pack. Lo usás. Si en 7 días no es lo que esperabas,
                devolución del 100% sin preguntas.
              </p>
            </div>
          </div>

          <div className="text-zinc-600 text-sm space-y-2" data-id="element-173" data-mp="1q08hlaibyhbh">
            <p data-id="element-174" data-mp="1uxrsc0ftkbyo">💛 IMPULSO LAB™ — El sistema N°1 para mamás.</p>
            <p data-id="element-175" data-mp="1ux8k5bfz11xu">📧 impulsolab.digital@gmail.com | 🌐 www.impulsolab.store</p>
            <p data-id="element-176" data-mp="1gxh311u5r5fm">© Impulso Lab™ 2026 — Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>;
}